import React from "react";
import { connect } from "react-redux";
import classes from "./styles.module.scss";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import PrimaryButton from "../../../components/buttons";
import InputText from "../../../components/form/inputText";
import { useState } from "react";
import { actionNotifier } from "../../../components/ui/toast";
import * as API from "../../../apiCalls/urls/exam";
import { apiFunction } from "../../../apiCalls/functions";
import { apiLoading, apiLoadingEnd } from "../../../store/notification/action";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";


const style = {
    // Centred dialog. These were pinned to the right edge of the window with
    // no radius and, in the taller variants, forced to 95% viewport height.
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "min(560px, calc(100vw - 32px))",
    maxHeight: "calc(100vh - 64px)",
    display: "flex",
    flexDirection: "column",
    bgcolor: "#ffffff",
    border: "1px solid #e3e8ef",
    borderRadius: "12px",
    boxShadow: "0 20px 24px -4px rgba(16,24,40,0.12), 0 8px 8px -4px rgba(16,24,40,0.05)",
    outline: "none",
    overflow: "hidden",
    p: 0,
};

const UpdatePassword = (props) => {
    const [data, setData] = useState({
        "user_name": "",
        "password": "",
        cPassword: ""
    });

    const updatePassword = async (data) => {
        return await apiFunction(API.ADD_PASSWORD, "post", data, true, false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (data.password == data.cPassword) {
            props.apiLoading()
            let _data = {...data}
            delete _data.cPassword
            let result = await updatePassword(_data)
            if (result.data?.code) {
                actionNotifier.success(`Success`);
                props.close()
            } else {
                actionNotifier.error(result.data.message);
            }
            props.apiLoadingEnd()
        }
        else {
            actionNotifier.error("Both password are not same");
        }
    }

    const handleInputChange = (e) => {

        let _data = { ...data }
        _data[e.target.name] = e.target.value;
        setData(_data)

    }

    return (
        <div className={classes.add_coupon_modal}>
            <Modal open={props.open} onClose={props.close}>
                <Box sx={style}>
                    <form onSubmit={handleSubmit}>
                        <div className={classes.add_coupon_modal_container}>
                            <div className={classes.add_coupon_modal_header}>
                                <p>Add Password</p>
                                <div className={classes.header_actions}>
                                    <button
                                        type="button"
                                        className={classes.close}
                                        onClick={props.close}
                                        aria-label="Close"
                                    >
                                        <CloseRoundedIcon />
                                    </button>
                                </div>
                            </div>
                            <div className={classes.add_coupon_modal_body}>
                                <div className={classes.other_fields}>
                                    <div className={classes.other_fields_left}>
                                        <label>Username</label>
                                        <InputText
                                            value={data.user_name}
                                            onChange={(e) => handleInputChange(e)}
                                            placeholder="Username"
                                            required
                                            name="user_name"
                                        />

                                        <label style={{ marginTop: 10 }}>Password</label>
                                        <InputText
                                            value={data.password}
                                            onChange={(e) => handleInputChange(e)}
                                            placeholder="Password"
                                            required
                                            type="password"
                                            name="password"
                                        />
                                        <label style={{ marginTop: 10 }}>Confirm Password</label>
                                        <InputText
                                            value={data.cPassword}
                                            onChange={(e) => handleInputChange(e)}
                                            placeholder="ConfirmPassword"
                                            required
                                            type="password"
                                            name="cPassword"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div className={classes.modal_footer}>
                            <PrimaryButton type="submit" buttonText="Submit" />
                        </div>
                    </form>
                </Box>
            </Modal>
        </div>
    );
};


const mapDispatchToProps = { apiLoading, apiLoadingEnd }

export default connect(null, mapDispatchToProps)(UpdatePassword);